import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { userAPIClient } from '@/infrastructure/user/api';

export function useUser() {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: ['user'],
    queryFn: () => userAPIClient.getUserInfo(),
    refetchOnWindowFocus: true,
    refetchOnMount: false,
  });

  const logoutMutation = useMutation({
    mutationFn: userAPIClient.logout,
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });

  if (!data) {
    return {
      isLoading,
      isFetching,
      isLoggedIn: false,
    };
  }

  const { isUserLoggedIn, capitalLetter, isSunwebCE } = data;

  return {
    isLoading,
    isFetching,
    isLoggedIn: isUserLoggedIn,
    capitalLetter,
    isSunwebCE,
    logout: logoutMutation.mutate,
  };
}
